export default __webpack_public_path__ + "static/desktop_7-c0d0c8425a20670dc9c191e59517d913.webp";